import _ from 'lodash';

const PHOTOSHOP_MIMES = new Set([
  'image/vnd.adobe.photoshop',
  'application/x-photoshop',
  'application/photoshop',
  'application/vnd.adobe.photoshop',
  'image/psd',
]);

class ValHelper {
  isDev = typeof window === undefined ? true : window.location.hostname.includes('dev.')|| process.env.NODE_ENV === 'development'
  editorHost = "https://msc-personify-editor.vercel.app";

  jsUCFirst = (string) => string.charAt(0).toUpperCase() + string.slice(1);

  formatBalance = (balance: number) => (Math.round(balance * 100) / 100).toFixed(2);

  isKeywordInFields = (values: string[], keyword: string) => {
    if (!values?.length) return false;
    if (!keyword) return true;
    const txt = values.map(i => String(i).toLowerCase()).join('|');
    return txt.includes(keyword.toLowerCase());
  }

  parseClientId = (id) => {
    if (Number(id)) return id;
    if (id === 'partnet-in-wine' || id === 'piw') return '665847158329';
    if (id === 'ghg') return '578953627077';
    return '440478626329';
  }

  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  formatMoney = (amount: string | number) => {
    const _amount = Number(amount || 0);
    if (Number.isNaN(_amount)) return amount || "0.00";
    return Number(amount || 0).toFixed(2)
  };

  objectToQueryString = (obj) => {
    return _.map(obj, (value, key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }).join('&');
  };

  toDisplayStage = (s?: string) => {
    if (!s || typeof s !== "string") return undefined;
    return s.split("-").map(_.capitalize).join(" ");
  };

  noSingleLastWordHTML = (value: string) => {
    if (typeof value !== 'string') return '';
    if (!value.trim().includes(" ")) return value;
    const parts = value.trim().split(" ");
    const length = parts.length;
    parts[length-2] = parts[length-2] + `\u00A0` + parts[length-1];
    parts[length-1] = '';
    return parts.join(" ");
  }

  calculateDPI = (widthMM: number, heightMM: number): number => {
    const minDPI = 300;
    const inchToMM = 25.4;
    
    let dpi = minDPI;
    while (true) {
      const pixelPerMM = dpi / inchToMM;
      const calculatedWidth = widthMM * pixelPerMM;
      const calculatedHeight = heightMM * pixelPerMM;
      const roundWidth = Math.round(calculatedWidth);
      const roundHeight = Math.round(calculatedHeight);

      const convertBackWidth = (roundWidth / pixelPerMM).toFixed(2);
      const convertBackHeight = (roundHeight / pixelPerMM).toFixed(2);

      if (convertBackWidth === widthMM.toFixed(2) && convertBackHeight === heightMM.toFixed(2)) {
        return dpi;
      }

      dpi += 1;
      if (dpi >= 500) return minDPI;
    }
  }

  /**
   * Parses an array field that might be stored as a string (JSON) or already be an array
   * @param field - The field value that could be a string, array, or undefined
   * @returns The parsed array, or empty array if field is invalid
   */
  parseArrayField = <T = any>(field: string | T[] | undefined | null): T[] => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    if (typeof field === 'string') {
      try {
        const parsed = JSON.parse(field);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  isPhotoshopLikeFile = (file: Pick<File, 'name' | 'type'>): boolean => {
    if (file.name.toLowerCase().endsWith('.psd')) return true;
    const t = (file.type || '').toLowerCase();
    return PHOTOSHOP_MIMES.has(t);
  };

  isDisallowedForImageStarAccept = (file: Pick<File, 'name' | 'type'>): boolean => {
    if (this.isPhotoshopLikeFile(file)) return true;
    if (file.type && !file.type.startsWith('image/')) return true;
    return false;
  };
}

export default new ValHelper();
